import {
  Accordion,
  AccordionHeader,
  AccordionItem,
  AccordionPanel,
  Button,
  MessageBar,
  MessageBarBody,
  MessageBarTitle,
  Text,
} from '@fluentui/react-components';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type ErrorMessage = {
  traceId?: string | null;
  timestamp?: string;
  statusCode?: number;
  message?: string | null;
};

interface IErrorMessageBarProps {
  messageBarTitle: string;
  error: ErrorMessage;
}

async function copyToClipboard(text: string): Promise<void> {
  await navigator.clipboard.writeText(text);
}

export function ErrorMessageBar({ error, messageBarTitle }: IErrorMessageBarProps) {
  const { t } = useTranslation();

  const errorObj = useMemo(
    () => ({
      errorMessage: error.message,
      traceId: error.traceId,
      timestamp: error.timestamp,
    }),
    [error],
  );

  return (
    <MessageBar intent="error" layout="multiline" style={{ paddingRight: 'var(--spacingHorizontalM)' }}>
      <MessageBarBody>
        <MessageBarTitle>{messageBarTitle}</MessageBarTitle>
        <Button
          onClick={() =>
            copyToClipboard(errorObj.errorMessage + ` Trace Id: ${errorObj.traceId} Time Stamp: ${errorObj.timestamp}`)
          }
        >
          {t('toast.copy')}
        </Button>
        {error && (
          <Accordion collapsible>
            <AccordionItem value="1">
              <AccordionHeader>{t('permissions.displayErrorDetails')} </AccordionHeader>
              <AccordionPanel style={{ display: 'flex', flexDirection: 'column' }}>
                <Text weight="semibold">{errorObj.errorMessage}</Text>
                <Text>Trace Id: {errorObj.traceId}</Text>
                <Text block>Time Stamp: {errorObj.timestamp}</Text>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        )}
      </MessageBarBody>
    </MessageBar>
  );
}
